// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote","quoteHgroup":"Quote-hgroup","quoteTitle":"Quote-title","quoteText":"Quote-text"};